import {
  ChangeDetectionStrategy,
  Component,
  input
} from "@angular/core";

@Component({
  selector: "app-package-description",
  templateUrl: "./package-description.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageDescriptionComponent {
  description = input<string>();
}
